import { disclaimerDocument, legalCompanyDetails } from "@mealmanager/legal-content";
import type { Route } from "./+types/page";
import LegalDocumentPage from "../components/LegalDocumentPage";
import { buildSeoMeta } from "../utils/seo";

export const meta: Route.MetaFunction = ({ location }) =>
  buildSeoMeta({
    location,
    title: `${disclaimerDocument.title} | ${legalCompanyDetails.brandName}`,
    description: `Read ${legalCompanyDetails.brandName}'s disclaimer for food, nutrition, allergy, meal-planning, and AI-assisted information.`,
    type: "article",
    modifiedTime: disclaimerDocument.effectiveDate,
  });

export default function DisclaimerPage() {
  return <LegalDocumentPage document={disclaimerDocument} />;
}
